import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";

export function C8({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.GRC001.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the cutlines (Schematic X, Y) of the following {row.data.length} cross sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}